import {
  BarChart,
  Bar,
  Rectangle,
  LabelList,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { useState, useEffect } from "react";
import "./Charts.css";
import { handleClickLogic } from "../../utils/filterFunctions";
import CustomBarLabel from "./CustomBarLabel";

const VerticalPositiveNegativeBarChart = ({ showData, xKey, title, selectedKey, frozenKey, onBarClick, height = 250, angle = 0, comparisonYear = 2025 }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [frozenData, setFrozenData] = useState(null);

  const dataToRender = isFrozen ? frozenData : showData;

  useEffect(() => {
    setSelectedCategory(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (frozenKey !== title) {
      setIsFrozen(false);
      setFrozenData(null);
    }
  }, [frozenKey, title]);

  const hasData = Array.isArray(dataToRender) && dataToRender.length > 0;

  if (!hasData) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }

  const colors = ['#00BFFF', '#FFA500'];
  const barKeys = Object.keys(dataToRender[0]).filter(key => key !== xKey);

  const showDataProcessed = dataToRender.map(item => {
    return {
      ...item,
      [comparisonYear]: item[comparisonYear] * -1
    };
  });

  const fontSize = showDataProcessed.length > 10 ? '10px' : '14px';

  const handleBarClick = (data) => {
    handleClickLogic({
      data,
      xKey,
      selectedCategory,
      isFrozen,
      showData,
      setIsFrozen,
      setFrozenData,
      setSelectedCategory,
      onBarClick,
    });
  };

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={showDataProcessed} stackOffset="sign" layout="vertical">
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" width="auto" tickFormatter={(value) => Math.abs(value)} />
            <YAxis type="category" dataKey={xKey} style={{ fontSize }} interval={0} textAnchor="end" angle={angle} />
            <Tooltip formatter={(value, name) => [Math.abs(value), name]} />
            <Legend />
            {barKeys.map((key, index) => (
              <Bar
                key={key}
                dataKey={key}
                fill={colors[index % colors.length]}
                stackId="stack"
                onClick={handleBarClick}
                shape={(props) => {
                  const category = props.payload?.[xKey];
                  const isSelected = selectedCategory === category;
                  const opacity = isFrozen
                    ? selectedCategory && !isSelected ? 0.4 : 1
                    : 1;
                  const stroke = isFrozen && isSelected ? "#333" : "none";
                  const strokeWidth = isFrozen && isSelected ? 2 : 0;
                  return (
                    <Rectangle
                      {...props}
                      fillOpacity={opacity}
                      stroke={stroke}
                      strokeWidth={strokeWidth}
                      cursor="pointer"
                    />
                  );
                }}>
                <LabelList dataKey={key} content={<CustomBarLabel chartType='posNegBar' />} />
              </Bar>
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default VerticalPositiveNegativeBarChart;

